import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetAllExtraObjectApi,
  GetAllExtraObjectsApi
} from "../Apis/ExtraObjectes/ExtraObjetcts_Api";

export const fetchGetAllExtraObjectApi = createAsyncThunk(
  "extraObjects/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetAllExtraObjectApi();
      return {
        data: response.data,
        status: response.status
      };
    } catch (error) {
      return rejectWithValue({
        error: error.message,
        status: error.response?.status || 500
      });
    }
  }
);

export const fetchGetAllExtraObjectsByidApi = createAsyncThunk(
  "extraObjects/fetchById",
  async (id) => {
    const response = await GetAllExtraObjectsApi(id);
    return response;
  }
);

const initialState = {
  data: [],
  isLoading: false
};

const ExtraObjectsSlice = createSlice({
  name: "ExtraObjects",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetAllExtraObjectApi.pending, (state) => {
        state.isLoading = true;
        state.data = [];
      })
      .addCase(fetchGetAllExtraObjectApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchGetAllExtraObjectApi.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(fetchGetAllExtraObjectsByidApi.pending, (state) => {
        state.isLoading = true;
        state.data = [];
      })
      .addCase(fetchGetAllExtraObjectsByidApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchGetAllExtraObjectsByidApi.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export default ExtraObjectsSlice.reducer;
